import { gql } from 'graphql-request'
import { botApi } from '@client/client'
import { Bots } from '@models/Bot/Bots'
import { BotStatusEnum } from '@interfaces/BotStatusEnum'
import { SortEnum } from '@interfaces/SortEnum'
import { BotMarketType } from '@interfaces/BotMarketEnum'

export const botsApi = botApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    bots: builder.query<
      Bots,
      {
        page: number
        limit: number
        status?: BotStatusEnum
        createAtStart?: number
        createAtEnd?: number
        endAtStart?: number
        endAtEnd?: number
        sort?: { createdAt?: SortEnum; endAt?: SortEnum }
        botMarketType?: BotMarketType
      }
    >({
      query: ({
        page,
        limit,
        status,
        createAtStart,
        createAtEnd,
        endAtStart,
        endAtEnd,
        sort,
        botMarketType,
      }) => ({
        document: gql`
          query Bots(
            $page: Int
            $limit: Int
            $status: BotStatus
            $createAtStart: Timestamp
            $createAtEnd: Timestamp
            $sort: BotSortInput
            $endAtStart: Timestamp
            $endAtEnd: Timestamp
            $botMarketType: BotMarketType
          ) {
            bots(
              page: $page
              limit: $limit
              status: $status
              create_at_start: $createAtStart
              create_at_end: $createAtEnd
              end_at_start: $endAtStart
              end_at_end: $endAtEnd
              sort: $sort
              bot_market_type: $botMarketType
            ) {
              bots {
                id
                symbol
                baseCurrencyData {
                  imgPath
                }
                botStrategy {
                  side
                }
                positionAvgPrice
                position {
                  contracts
                  collateral
                  unrealizedPnl
                }
                profit
                status
                coverRound
                endAt
                errorDescription
              }
              pagination {
                totalPage
                totalCount
              }
            }
          }
        `,
        variables: {
          page,
          limit,
          status,
          createAtStart,
          createAtEnd,
          sort,
          endAtStart,
          endAtEnd,
          botMarketType,
        },
      }),
      transformResponse(res: { bots: Bots }) {
        const { bots } = res
        return bots
      },
      providesTags: (result, error, arg) => [{ type: 'Bots', ...arg }],
    }),
  }),
})

export const { useBotsQuery } = botsApi
